var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col p-6 bg-lightest"},[_c('h2',{staticClass:"text-dark text-2xl font-semibold mb-1"},[_vm._v("User Response")]),_c('p',{staticClass:"text-dark text-xl"},[_vm._v(_vm._s(_vm.items[0]))])])}
var staticRenderFns = []

export { render, staticRenderFns }